export const ERROR_COMPONENTS_TRANSLATION_NAMESPACE = "error-components";

export const ERROR_PAGE_TK = "ERROR_PAGE_TK";
